import React, { useState } from 'react';
import './AnotacoesOcorrencias.css';

const AnotacoesOcorrencias = () => {
  const [selectedType, setSelectedType] = useState('all');
  const [selectedDate, setSelectedDate] = useState('today');
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  const types = [
    { id: 'all', label: 'Todas', icon: '📝', color: '#6b7280' },
    { id: 'positivo', label: 'Positivo', icon: '✅', color: '#10b981' },
    { id: 'negativo', label: 'Negativo', icon: '⚠️', color: '#ef4444' },
    { id: 'observacao', label: 'Observação', icon: '👁️', color: '#3b82f6' },
    { id: 'comportamento', label: 'Comportamento', icon: '🎭', color: '#f59e0b' }
  ];

  const dateFilters = [
    { id: 'today', label: 'Hoje' },
    { id: 'week', label: 'Esta Semana' },
    { id: 'month', label: 'Este Mês' },
    { id: 'all', label: 'Todas' }
  ];

  const occurrences = [
    {
      id: 1,
      type: 'positivo',
      title: 'Excelente Participação',
      student: 'João Silva',
      turma: '9º ano A',
      date: '2026-02-06',
      time: '09:30',
      description: 'João demonstrou excelente compreensão do conteúdo de equações quadráticas e ajudou os colegas durante os exercícios em grupo.',
      professor: 'Prof. Maria Santos',
      tags: ['participação', 'ajuda', 'matemática'],
      resolved: true
    },
    {
      id: 2,
      type: 'negativo',
      title: 'Conversa Durante Aula',
      student: 'Pedro Oliveira',
      turma: '9º ano B',
      date: '2026-02-06',
      time: '10:15',
      description: 'Pedro estava conversando durante a explicação sobre Revolução Industrial, atrapalhando a concentração dos colegas.',
      professor: 'Prof. Carlos Ferreira',
      tags: ['comportamento', 'atenção', 'história'],
      resolved: false,
      action: 'Conversa particular após aula'
    },
    {
      id: 3,
      type: 'observacao',
      title: 'Dificuldade em Matemática',
      student: 'Ana Costa',
      turma: '9º ano A',
      date: '2026-02-05',
      time: '14:20',
      description: 'Ana apresentou dificuldades específicas na aplicação da fórmula de Bhaskara. Necessita reforço em cálculos.',
      professor: 'Prof. Maria Santos',
      tags: ['dificuldade', 'matemática', 'cálculo'],
      resolved: false,
      action: 'Agendada aula de reforço para próxima semana'
    },
    {
      id: 4,
      type: 'positivo',
      title: 'Liderança em Grupo',
      student: 'Lucas Mendes',
      turma: '9º ano B',
      date: '2026-02-05',
      time: '11:00',
      description: 'Lucas demonstrou grande capacidade de liderança durante o trabalho em grupo sobre o sistema digestório, organizando as tarefas e motivando os colegas.',
      professor: 'Prof. Roberta Lima',
      tags: ['liderança', 'grupo', 'ciências'],
      resolved: true
    },
    {
      id: 5,
      type: 'comportamento',
      title: 'Agressividade no Recreio',
      student: 'Gabriel Almeida',
      turma: '8º ano A',
      date: '2026-02-04',
      time: '16:30',
      description: 'Gabriel envolveu-se em conflito físico durante o recreio. Situação foi contida pelos monitores.',
      professor: 'Prof. Marcos Silva',
      tags: ['conflito', 'recreio', 'agressividade'],
      resolved: true,
      action: 'Pais foram comunicados e aluno encaminhado à psicologia'
    },
    {
      id: 6,
      type: 'observacao',
      title: 'Progresso em Português',
      student: 'Mariana Souza',
      turma: '9º ano A',
      date: '2026-02-04',
      time: '08:00',
      description: 'Mariana apresentou notável melhora na produção textual, com maior coesão e clareza nas argumentações.',
      professor: 'Prof. Carla Dias',
      tags: ['progresso', 'português', 'redação'],
      resolved: true
    },
    {
      id: 7,
      type: 'negativo',
      title: 'Não Entregou Trabalho',
      student: 'Rafael Santos',
      turma: '9º ano B',
      date: '2026-02-03',
      time: '13:30',
      description: 'Rafael não entregou o trabalho de história sobre a Revolução Industrial na data prevista.',
      professor: 'Prof. Carlos Ferreira',
      tags: ['tarefa', 'entrega', 'história'],
      resolved: false,
      action: 'Nova data definida: 10/02/2026'
    },
    {
      id: 8,
      type: 'positivo',
      title: 'Iniciativa em Projeto',
      student: 'Isabella Costa',
      turma: '8º ano A',
      date: '2026-02-03',
      time: '10:45',
      description: 'Isabella demonstrou grande iniciativa ao propor melhorias no projeto de feira de ciências, trazendo ideias criativas e bem fundamentadas.',
      professor: 'Prof. Roberta Lima',
      tags: ['iniciativa', 'projeto', 'ciências'],
      resolved: true
    }
  ];

  const filteredOccurrences = occurrences.filter(occurrence => {
    const matchesType = selectedType === 'all' || occurrence.type === selectedType;
    const matchesSearch = occurrence.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         occurrence.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         occurrence.student.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         occurrence.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesType && matchesSearch;
  });

  const getTypeInfo = (typeId) => {
    return types.find(type => type.id === typeId) || types[0];
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const getPriorityColor = (type) => {
    switch (type) {
      case 'negativo': return '#ef4444';
      case 'positivo': return '#10b981';
      case 'observacao': return '#3b82f6';
      case 'comportamento': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  return (
    <div className="anotacoes-container">
      <div className="anotacoes-header">
        <h2>📝 Anotações e Ocorrências</h2>
        <p>Registre anotações e ocorrências diárias dos alunos</p>
      </div>

      <div className="controls-section">
        <div className="filters-row">
          <div className="filter-group">
            <label>Tipo:</label>
            <div className="type-filters">
              {types.map(type => (
                <button
                  key={type.id}
                  className={`type-filter ${selectedType === type.id ? 'active' : ''}`}
                  style={{ borderColor: selectedType === type.id ? type.color : '#e5e7eb' }}
                  onClick={() => setSelectedType(type.id)}
                >
                  <span className="type-icon">{type.icon}</span>
                  <span className="type-label">{type.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="filter-group">
            <label>Período:</label>
            <div className="date-filters">
              {dateFilters.map(filter => (
                <button
                  key={filter.id}
                  className={`date-filter ${selectedDate === filter.id ? 'active' : ''}`}
                  onClick={() => setSelectedDate(filter.id)}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="search-section">
          <div className="search-input-wrapper">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              placeholder="Buscar ocorrências..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
          <button 
            className="add-occurrence-btn"
            onClick={() => setShowAddModal(true)}
          >
            ➕ Nova Ocorrência
          </button>
        </div>
      </div>

      <div className="stats-section">
        <div className="stats-grid">
          <div className="stat-card positivo">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <span className="stat-number">{occurrences.filter(o => o.type === 'positivo').length}</span>
              <span className="stat-label">Positivas</span>
            </div>
          </div>
          <div className="stat-card negativo">
            <div className="stat-icon">⚠️</div>
            <div className="stat-content">
              <span className="stat-number">{occurrences.filter(o => o.type === 'negativo').length}</span>
              <span className="stat-label">Negativas</span>
            </div>
          </div>
          <div className="stat-card observacao">
            <div className="stat-icon">👁️</div>
            <div className="stat-content">
              <span className="stat-number">{occurrences.filter(o => o.type === 'observacao').length}</span>
              <span className="stat-label">Observações</span>
            </div>
          </div>
          <div className="stat-card pendente">
            <div className="stat-icon">⏳</div>
            <div className="stat-content">
              <span className="stat-number">{occurrences.filter(o => !o.resolved).length}</span>
              <span className="stat-label">Pendentes</span>
            </div>
          </div>
        </div>
      </div>

      <div className="occurrences-section">
        <div className="occurrences-header">
          <h3>Ocorrências Registradas</h3>
          <span className="results-count">{filteredOccurrences.length} resultados</span>
        </div>

        <div className="occurrences-list">
          {filteredOccurrences.map(occurrence => {
            const typeInfo = getTypeInfo(occurrence.type);
            return (
              <div key={occurrence.id} className="occurrence-card">
                <div className="occurrence-header">
                  <div className="occurrence-type" style={{ backgroundColor: typeInfo.color }}>
                    <span className="type-icon">{typeInfo.icon}</span>
                    <span className="type-name">{typeInfo.label}</span>
                  </div>
                  <div className="occurrence-meta">
                    <span className="occurrence-date">📅 {formatDate(occurrence.date)}</span>
                    <span className="occurrence-time">⏰ {occurrence.time}</span>
                    <span className={`status-badge ${occurrence.resolved ? 'resolved' : 'pending'}`}>
                      {occurrence.resolved ? '✅ Resolvido' : '⏳ Pendente'}
                    </span>
                  </div>
                </div>

                <div className="occurrence-content">
                  <h4>{occurrence.title}</h4>
                  
                  <div className="student-info">
                    <span className="student-name">👤 {occurrence.student}</span>
                    <span className="turma-info">👥 {occurrence.turma}</span>
                    <span className="professor-info">👨‍🏫 {occurrence.professor}</span>
                  </div>

                  <p className="occurrence-description">{occurrence.description}</p>

                  {occurrence.action && (
                    <div className="action-taken">
                      <span className="action-label">📋 Ação Tomada:</span>
                      <span className="action-text">{occurrence.action}</span>
                    </div>
                  )}

                  <div className="occurrence-tags">
                    {occurrence.tags.map((tag, index) => (
                      <span key={index} className="tag">#{tag}</span>
                    ))}
                  </div>

                  <div className="occurrence-actions">
                    <button className="action-btn edit">
                      ✏️ Editar
                    </button>
                    <button className="action-btn resolve">
                      {occurrence.resolved ? '🔄 Reabrir' : '✅ Resolver'}
                    </button>
                    <button className="action-btn share">
                      📤 Compartilhar
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filteredOccurrences.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">📝</div>
            <h3>Nenhuma ocorrência encontrada</h3>
            <p>Tente ajustar os filtros ou o termo de busca</p>
          </div>
        )}
      </div>

      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>📝 Nova Ocorrência</h3>
              <button className="close-btn" onClick={() => setShowAddModal(false)}>
                ✖️
              </button>
            </div>
            <div className="modal-body">
              <form className="occurrence-form">
                <div className="form-group">
                  <label>Tipo de Ocorrência</label>
                  <select className="form-select">
                    <option value="">Selecione...</option>
                    {types.filter(t => t.id !== 'all').map(type => (
                      <option key={type.id} value={type.id}>{type.label}</option>
                    ))}
                  </select>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label>Aluno</label>
                    <input type="text" className="form-input" placeholder="Nome do aluno" />
                  </div>
                  <div className="form-group">
                    <label>Turma</label>
                    <select className="form-select">
                      <option value="">Selecione...</option>
                      <option value="9a">9º ano A</option>
                      <option value="9b">9º ano B</option>
                      <option value="8a">8º ano A</option>
                      <option value="8b">8º ano B</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label>Título</label>
                  <input type="text" className="form-input" placeholder="Título da ocorrência" />
                </div>

                <div className="form-group">
                  <label>Descrição</label>
                  <textarea className="form-textarea" rows="4" placeholder="Descreva detalhadamente a ocorrência..."></textarea>
                </div>

                <div className="form-group">
                  <label>Ação Tomada (opcional)</label>
                  <input type="text" className="form-input" placeholder="Descreva a ação que foi ou será tomada" />
                </div>

                <div className="form-group">
                  <label>Tags (separadas por vírgula)</label>
                  <input type="text" className="form-input" placeholder="ex: comportamento, atenção, matemática" />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowAddModal(false)}>
                Cancelar
              </button>
              <button className="btn-primary">
                💾 Salvar Ocorrência
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnotacoesOcorrencias;
